<template>
<div class="terms">
  <el-dialog
    top="1vh"
    title="Terms and Conditions"
    :visible.sync="show"
    :width="dialogWidth"
    custom-class="s-conditions">
    <el-button type="info" icon="el-icon-printer" circle v-print="'#dialog'" class="gh-print"></el-button>

     <div class="offer-conditions" id="dialog">
          <p class="offer-conditions__p">The 2022 Suicide Prevention Summit (“Event”) is operated and owned by the Mental Health Academy (“MHA”). By choosing to participate in the 2022 Suicide Prevention Summit as a registered user you agree to the following terms and conditions, whether you have read the terms and conditions or not.</p>
          <p><strong>Disclaimer</strong></p>
          <p class="offer-conditions__p">MHA reserves the right to change the materials, programs, services and products at the 2022 Suicide Prevention Summit entirely at its discretion. Opinions of presenters and contributors to the Event are not necessarily those of MHA or its event partners. Use of material from the Event is not intended to substitute professional, legal, financial or medical advice. When advice is required, we encourage you to seek out a qualified professional.</p>
          <p class="offer-conditions__p">MHA makes no representation or warranty that information provided via the Event is accurate, nor accepts liability or responsibility for any action arising out of information provided. You agree to use the information from the Event at your own risk and take sole responsibility for the choices you make.</p>
          <p><strong>Copyright</strong></p>
          <p class="offer-conditions__p">All content from the 2022 Suicide Prevention Summit is the property of the presenters and suppliers and is protected by international copyright laws. This includes but is not limited to the presentations. You are not permitted to use or reproduce any content whatsoever without the express written consent of the copyright owner.</p>
          <p><strong>Access to Content</strong></p>
          <p class="offer-conditions__p">Your registration to the 2022 Suicide Prevention Summit provides you with access to 10 hours of continuing professional development (CPD), delivered online via live webinars (September 10 & 11, 2022) and video recordings (available after the live sessions). While you may choose to pay an attendance fee, your choice (free registration or £10) determines the timeframe you can access video recordings, and the resources that are included with your registration, as outlined below:</p>
          <p class="offer-conditions__p">The free registration option includes access to:</p>
          <ul>
              <li>All live webinars* (September 10 & 11, 2022)</li>
              <li>7-day access to video recordings</li>
          </ul>
          <p class="offer-conditions__p">The&nbsp;£10 (Premium) registration fee includes access to:</p>
          <ul>
              <li>All live webinars* (September 10 & 11, 2022)</li>
              <li>Extended access to video recordings (November 6, 2022)</li>
              <li>Session slides (available in PDF format for download)</li>
              <li>Post-session Notes (available in PDF format for download)</li>
          </ul>
          <p class="offer-conditions__p">*Live webinar sessions are delivered via the WebinarJam platform and can hold a maximum of 5,000 concurrent attendees. Available spots are allocated automatically by the webinar system on a first in, first served basis for each webinar session. While it is unlikely, if you miss out on a real-time webinar session due to capacity being reached, you will be able to watch a recorded version of the session (including Q&A discussion) after the live event (see timeframes for access above).</p>
          <p><strong>Social Impact</strong></p>
          <p class="offer-conditions__p">Mental Health Academy will donate all revenue raised from event registrations to the British Psychological Society (BPS). </p>
          <p><strong>Registration Upgrades</strong></p>
          <p class="offer-conditions__p">You may choose to upgrade a free registration to Premium (£10). By upgrading, you will immediately gain access to resources available via the £10 (Premium) registration option (see “Access to Content” section above for more details).</p>
          <p><strong>Registration Confirmation</strong></p>
          <p class="offer-conditions__p">Upon submitting your registration to attend the 2022 Suicide Prevention Summit, you will receive an instant confirmation via the registration page. You will also receive email confirmation. Please make sure you check both your email inbox and other mail folders (including junk and promotions). If you do not receive an email confirmation, contact us to obtain a copy.</p>
          <p class="offer-conditions__p">We also recommend adding <a href="mailto:admin@mentalhealthacademy.co.uk">admin@mentalhealthacademy.co.uk</a> to your email contact list to avoid further emails being blocked by your email SPAM filter and other security settings.</p>
          <p><strong>CPD Certificates</strong></p>
          <p class="offer-conditions__p">Participants of the 2022 Suicide Prevention Summit will gain access to CPD Certificates as evidence of their registration and participation. Instructions to complete evaluation surveys and access CPD Certificates of Attendance will be emailed to registered users during and after the live event period (September 10 & 11, 2022). Refer to the Event’s ongoing email communications and updates for more information. If you cannot locate email instructions, please contact us for assistance.</p>
          <p><strong>Refund Policy</strong></p>
          <p class="offer-conditions__p">As all revenue from this event will be donated to charity, the paid registration fee (£10) for the 2022 Suicide Prevention Summit is non-refundable. Requests for refunds under special circumstances will be considered and reviewed on a per case basis.</p>
          <p><strong>International Transaction Fees</strong></p>
          <p class="offer-conditions__p">All payments are processed in GBP (British Pounds). Some card issuers may charge additional “international fees” to process your payment, depending on your card’s specific terms & conditions (and due to MHA’s head office being located in Australia). MHA is unable to provide refunds or invoices for transaction fees, as these fees are charged by your card issuer, not MHA.</p>
          <p><strong>Website Usage</strong></p>
          <p class="offer-conditions__p">Your access to the 2022 Suicide Prevention Summit only gives you the right to access and use the Summit’s resources. You are not permitted to share your access details with others. Your access does not in any way imply ownership of any material. You are not permitted to publicly share any of the Event’s resources.</p>
          <p class="offer-conditions__p">If you have any queries, please contact us via <a href="mailto:help@mentalhealthacademy.co.uk">help@mentalhealthacademy.co.uk</a>.</p>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="show = false" class="gh-button gh-button--primary">Close</el-button>
    </span>
    </el-dialog>
</div>
</template>

<script>

export default {

  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      show: false
    }
  },

  computed: {
      dialogWidth() {
          return this.device !=='widescreen' && this.device !=='desktop' ? '85%' : '50%'
      },

      device() {
          return this.$store.getters['ui/getDevice'];
      }
  },

  watch: {
    show() {
      if (!this.show) {
        this.$emit('hide')
      }
    },

    dialogVisible () {
      if (this.dialogVisible) {
        this.show = true
      } else {
        this.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .gh-print {
        font-size: 1.5rem;
        right: 4rem;
        position: absolute;
        top: 1rem;
        width: 50px !important;
        background: #909399;
        border-color: #909399;
    }
    .offer-conditions__p{
        font-size: 1.1rem;
        padding-bottom: 1rem;
        word-break: keep-all;
    }

    ul {
      list-style: disc;
      padding: 0 0 1rem 2rem;
      font-size: 15px;

      li + li {
        margin-top: .5rem;
      }
    }
</style>